// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DN-U","placeholdersHeader":"styles_placeholdersHeader__16hCG","editorStyle":"styles_editorStyle__IabQ8","placeholdersBox":"styles_placeholdersBox__2rBXB"};